
import StationsMap from "views/Public/Components/StationsMap";

function SingleMarkerMap({point, text}) {
    if (!point || !point[0] || !point[1]) {
        return <div>Lat/Lon inválida</div>
    }

    return (
        <StationsMap stations={[{lat: point[0], long: point[1], identifier: 'single-marker'}]} text={text} center={point} zoom={10}/>
    )
}

export default SingleMarkerMap;
